export default __webpack_public_path__ + "static/media/wami-full.3ac53c18.svg";